import gql from "graphql-tag";

export const MY_HR_EMPLOYEES_SUBSCRIPTION = gql`
  subscription employeesSubscription {
    employeesSubscription
  }
`;
